import { useTranslation } from 'react-i18next'
import UnitWarningContainer from './UnitWarningContainer'

export default function AppliedCouponsBanner({ appliedCoupons }) {
  const { t } = useTranslation()
  const validCoupons = Array.isArray(appliedCoupons)
    ? appliedCoupons.filter((coupon) => {
        const amount = Number(coupon?.amount)
        return typeof coupon?.name === 'string' && coupon.name.trim() !== '' && Number.isFinite(amount) && amount > 0
      })
    : []

  if (validCoupons.length === 0) {
    return null
  }

  const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

  return (
    <UnitWarningContainer colorStyles="text-yellow border-yellow">
      <div data-testid="applied-coupons-banner" className="flex flex-col items-center px-2 text-center">
        {validCoupons.map((coupon) => (
          <div key={coupon.id ?? `${coupon.name}-${coupon.amount}`}>
            {t('Coupon applied: {{name}} – {{amount}} discount', {
              name: coupon.name,
              amount: currencyFormatter.format(Number(coupon.amount)),
              interpolation: { escapeValue: false },
            })}
          </div>
        ))}
      </div>
    </UnitWarningContainer>
  )
}
